import Api from './Indicadores'
export default {
    getUserData(){
        return Api().get("/user/data");
    },
    getUsersByCompany(id){
        return Api().get("/user/company/"+id)
    },
    getUsersByCompanyAll(id){
        return Api().get("/user/company-all/"+id)
    },
    getQueryName(query){
        return Api().get("/user/query/name/"+query)
    },
    createUser(data){
        return Api().post("/user/createInCompany/",data)
    },
    
    deleteUserCompany(userId, companyId){
        return Api().delete("/user/deleteInCompany/"+userId+ "/"+companyId)
    },
    updateUserLite(user){
        return Api().post("/user/data/update-lite", user);
    },
    getBySector(sectorId){
        return Api().get('/user/sector/'+sectorId);
    },

    sectorDelete(sectorId){
        return Api().delete("/user/sector/"+sectorId)
    },
    sectorInsert(userId, sectorId, leadershipId){
        return Api().post("/user/sector/add/"+userId+"/"+sectorId+ "/"+leadershipId)
    },
    getUsername(id){
        return Api().get("/user/data/username/"+id);
    }
}